import reduxCrud from 'redux-crud';

const driversActionCreators = reduxCrud.actionCreatorsFor('drivers', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('drivers', { key: 'id' });

export default driversActionCreators;
export { actionTypes };
